module.exports = __webpack_public_path__ + "img/social_accounts_modal_bg.svg";